import { $getSelection, $isRangeSelection } from "lexical";
import React from "react";
import { LexicalProps } from "../LexicalEditor.types";
import { CopyIcon } from "../../../assets/icons/SvgIcons";
import { copyToClipboard } from "@lexical/clipboard";

const Copy = ({ editor, isDropdown }: LexicalProps) => {
  const handleCopy = () => {
    editor.update(() => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        copyToClipboard(editor, null).catch((err) => {
          console.error("Failed to copy content: ", err);
        });
      }
    });
  };

  return (
    <div
      className={`lexical-toolbarItem ${
        isDropdown ? "lexical-dropdownItem" : ""
      }`}
      onClick={handleCopy}
    >
      <div className="lexical-shortcutWrapper">
        <CopyIcon />
        <span className="lexical-shortcutText">Copy</span>
      </div>
      <span className="lexical-shortcut">Ctrl+C</span>
    </div>
  );
};

export default Copy;
